exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".CategoryTile {\n  position: relative;\n  height: 300px;\n  width: 300px;\n  /* border-left: 1px solid black; */\n  /* border-top: 1px solid black; */\n  border: 1px solid black; }\n\n.CategoryTile:hover {\n  color: black; }\n\n.CategoryTileOverlay {\n  position: absolute;\n  font-family: 'Vollkorn', serif;\n  font-weight: 400;\n  top: 10px;\n  left: 10px;\n  padding-left: 5px;\n  background-color: white;\n  text-decoration: none;\n  border-radius: 0, 0, 3px, 0;\n  color: black;\n  width: 230px;\n  vertical-align: center;\n  text-transform: uppercase;\n  box-sizing: border-box; }\n", ""]);

// exports
